import React from "react";
import * as Lucide from "lucide-react";
import { Briefcase } from "lucide-react";

// Map kebab-case icon names from DB → Lucide PascalCase component names.
function toPascal(name) {
  if (!name) return null;
  return name
    .split(/[-_\s]+/)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join("");
}

export default function IndustryIcon({ name, size = 22, className = "" }) {
  const pascal = toPascal(name);
  const Component = (pascal && Lucide[pascal]) || Briefcase;
  return <Component size={size} className={className} strokeWidth={1.5} />;
}
